import { Link, Navigate, useParams } from 'react-router-dom';
import TicketBuilder from '../components/TicketBuilder';
import UploadGames from '../components/UploadGames';
import { ArrowLeft } from 'lucide-react';
import { Toaster } from 'sonner';
import WeeklyLockList from '../components/WeeklyLockList';
import CfbBlowoutBoard from '../components/CfbBlowoutBoard';
import AIPicksTab from '../components/AIPicksTab';
import PicksNotOnTickets from '../components/PicksNotOnTickets';
import SuggestionsTab from '../components/SuggestionsTab';

const PAGES = {
  college: { title: 'College Football', sub: 'Blowout locks and AI game picks' },
  nfl: { title: 'NFL — Sunday Best Bets', sub: 'Player marks by game, injuries, suggested ticket' },
};

export default function SportsPicksPage() {
  const { league } = useParams();
  const page = PAGES[league];
  if (league === 'nfl') return <Navigate to="/sports-betting/ai-picks" replace />;
  if (!page) return <Navigate to="/sports-betting" replace />;
  if (sessionStorage.getItem('sports_betting_authed') !== 'true') return <Navigate to="/sports-betting" replace />;
  return (
    <div className="min-h-screen bg-zinc-950 text-white p-4 md:p-6" data-testid={`picks-page-${league}`}>
      <Toaster position="top-right" theme="dark" />
      <div className="max-w-5xl mx-auto space-y-5">
        <div className="flex items-center justify-between gap-3 flex-wrap">
          <Link to="/sports-betting" className="text-sm text-zinc-400 hover:text-white flex items-center gap-1" data-testid="back-to-tickets">
            <ArrowLeft className="w-4 h-4" /> My tickets
          </Link>
          <div className="text-right">
            <h1 className="text-lg md:text-xl font-bold">{page.title}</h1>
            <p className="text-[11px] text-zinc-500">{page.sub}</p>
          </div>
        </div>
        {league === 'college' ? (
          <>
            <TicketBuilder league="cfb" />
            <UploadGames league="cfb" />
            <PicksNotOnTickets league="cfb" />
            <CfbBlowoutBoard />
            <WeeklyLockList only="cfb" />
            <AIPicksTab fixedLeague="cfb" />
          </>
        ) : (
          <>
            <SuggestionsTab />
            <WeeklyLockList only="nfl" />
            <AIPicksTab fixedLeague="nfl" />
          </>
        )}
      </div>
    </div>
  );
}
